(function (window) {
  'use strict';

  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;
  const originalConsoleLog = console.log;

  const nowIso = () => {
    try { return new Date().toISOString(); } catch (e) { return String(Date.now()); }
  };

  const safeJson = (obj, fallback) => {
    try { return JSON.stringify(obj); } catch (e) { return fallback || '{}'; }
  };

  const genId = () => (
    Date.now().toString(36) + '-' +
    Math.random().toString(36).slice(2, 10) + '-' +
    Math.random().toString(36).slice(2, 7)
  );

  const utf8Bytes = (str) => {
    try {
      if (window.TextEncoder) return new TextEncoder().encode(str).length;
    } catch (e) {}
    // fallback approximate
    let bytes = 0;
    for (let i = 0; i < str.length; i++) {
      const c = str.charCodeAt(i);
      if (c <= 0x7f) bytes += 1;
      else if (c <= 0x7ff) bytes += 2;
      else if (c >= 0xd800 && c <= 0xdbff) { bytes += 4; i += 1; }
      else bytes += 3;
    }
    return bytes;
  };

  const normalizeLevel = (level) => {
    const lvl = String(level || '').toUpperCase();
    if (lvl === 'INFO' || lvl === 'WARN' || lvl === 'ERROR') return lvl;
    return 'INFO';
  };

  const normalizeMessage = (message) => {
    if (typeof message === 'string') return message;
    return safeJson(message, '[unserializable message]');
  };

  const normalizeData = (data) => {
    if (data && typeof data === 'object' && !Array.isArray(data)) return data;
    return { value: data };
  };

  const addErrorsListeners = () => {
    window.addEventListener('error', (event) => {
      let errorInfo

      let message
      if (event.target === window) {
        errorInfo = {
          message: event.message,
          source: event.filename || event.source,
          lineno: event.lineno,
          colno: event.colno,
          error: event.error ? {
            message: event.error.message,
            stack: event.error.stack,
            name: event.error.name
          } : null
        };
        message = `Runtime error: ${errorInfo.message} at ${errorInfo.source}:${errorInfo.lineno}:${errorInfo.colno}`;

      } else {
        message = `Resource loading error`;
        errorInfo = {
          tagName: event.target.tagName,
          src: event.target.src || event.target.href,
        }
      }

      try {
        if (window.curacaoLogger) {
          curacaoLogger.log('ERROR', message, errorInfo);
        } else {
          originalConsoleError.call(console, 'Runtime error:', errorInfo);
        }
      } catch (e) {
        originalConsoleError.call(console, 'Error in error handler:', e);
      }
    }, true);

    // promise errors
    window.addEventListener('unhandledrejection', (event) => {
      const { reason } = event

      let message, errorData
      if (reason instanceof Error) {
        message = `Unhandled promise rejection: ${reason.message}`;
        errorData = {
          message: reason.message,
          stack: reason.stack,
          name: reason.name
        };
      } else if (typeof reason === 'string') {
        message = `Unhandled promise rejection: ${reason}`;
        errorData = { reason };
      } else {
        message = `Unhandled promise rejection: ${safeJson(reason, String(reason))}`;
        errorData = { reason: normalizeData(reason) };
      }


      try {
        if (window.curacaoLogger) {
          curacaoLogger.log('ERROR', message, errorData);
        } else {
          originalConsoleError.call(console, 'Promise Rejected:', event.reason);
        }
      } catch (e) {
        originalConsoleError.call(console, 'Error in promise rejection handler:', e);
      }
    });


    console.error = function (...args) {
      if (typeof curacaoLogger === 'undefined') {
        originalConsoleError.apply(console, args);
        return
      }

      try {
        const message = args.map(arg => {
          if (typeof arg === 'string') return arg;
          if (arg instanceof Error) return arg.message + (arg.stack ? '\n' + arg.stack : '');

          try {
            return JSON.stringify(arg);
          } catch (e) {
            return String(arg);
          }
        }).join(' ');

        curacaoLogger.log('ERROR', message);
      } catch (e) {
        originalConsoleLog.call(console, 'Error in logger:', e);
        originalConsoleError.apply(console, args);
      }
    };

  }

  class CuracaoLogger {
    constructor(options) {
      this.cfg = {
        endpoint: '',
        /**
         * CORS strategy:
         * - 'auto' (default): same-origin -> normal CORS fetch with ACK; cross-origin -> best-effort no-cors (no ACK)
         * - 'cors': always use normal CORS fetch (requires server CORS headers)
         * - 'no-cors': always best-effort (no response visibility)
         */
        corsMode: 'auto',

        flushIntervalMs: 15000,
        maxBatchItems: 200,
        maxQueueItems: 2000,

        maxBatchBytes: 200000,

        closeTransportMaxBytes: 60000,// ~64KB limit of beacon payload

        // fetch timeout for normal flush
        timeoutMs: 7000,

        // backoff
        backoffBaseMs: 1000,
        backoffMaxMs: 300000 // 5 min
      };

      this.queue = [];
      this.queueBytes = 0;
      this.sessionId = null;

      this._timer = null;
      this._flushing = false;

      this._lastCloseFlushAt = 0;

      this._backoffMs = 0;
      this._backoffUntil = 0;

      this.configure(options);

      this._ensureSessionId();
      this._startTimer();
      this._bindCloseFlush();
    }

    configure(options) {
      if (!options) return;

      if (typeof options.endpoint === 'string') this.cfg.endpoint = options.endpoint;
      if (typeof options.corsMode === 'string') this.cfg.corsMode = options.corsMode;

      if (options.flushIntervalMs != null) this.cfg.flushIntervalMs = Number(options.flushIntervalMs) || this.cfg.flushIntervalMs;
      if (options.maxBatchItems != null) this.cfg.maxBatchItems = Number(options.maxBatchItems) || this.cfg.maxBatchItems;
      if (options.maxQueueItems != null) this.cfg.maxQueueItems = Number(options.maxQueueItems) || this.cfg.maxQueueItems;

      if (options.maxBatchBytes != null) this.cfg.maxBatchBytes = Number(options.maxBatchBytes) || this.cfg.maxBatchBytes;
      if (options.closeTransportMaxBytes != null) this.cfg.closeTransportMaxBytes = Number(options.closeTransportMaxBytes) || this.cfg.closeTransportMaxBytes;

      if (options.timeoutMs != null) this.cfg.timeoutMs = Number(options.timeoutMs) || this.cfg.timeoutMs;

      this._startTimer();
    }

    setSessionId(id) {
      if (!id) return;
      this.sessionId = String(id);
      try { sessionStorage.setItem('curacao_logger_session_id_v1', this.sessionId); } catch (e) {}
    }

    getSessionId() { this._ensureSessionId(); return this.sessionId; }

    log(level, message, data) {
      if (level === 'ERROR') {
        originalConsoleError.call(console, message, data)
      } else if (level === 'WARN') {
        originalConsoleWarn.call(console, message, data)
      } else {
        originalConsoleLog.call(console, message, data)
      }

      if (!this.cfg.endpoint) return;

      this._ensureSessionId();

      const entry = {
        log_id: genId(),
        level: normalizeLevel(level),
        message: normalizeMessage(message),
        timestamp: nowIso(),
        sessionId: this.sessionId
      };

      if (data) {
        entry.data = normalizeData(data)
      }

      const entryJson = safeJson(entry, null);
      const entryBytes = entryJson ? utf8Bytes(entryJson) : 0;

      if (entryBytes > this.cfg.maxBatchBytes) {
        this._sendSingle(entry);
        return;
      }

      if (this.queue.length && (this.queueBytes + entryBytes > this.cfg.maxBatchBytes)) {
        this.flush({ reason: 'maxBatchBytes' });
      }

      while (this.queue.length >= this.cfg.maxQueueItems) {
        const removed = this.queue.shift();
        this.queueBytes -= (removed && removed._bytes) ? removed._bytes : 0;
        if (this.queueBytes < 0) this.queueBytes = 0;
      }

      entry._bytes = entryBytes;
      this.queue.push(entry);
      this.queueBytes += entryBytes;

      if (this.queue.length >= this.cfg.maxBatchItems) {
        this.flush({ reason: 'maxBatchItems' });
      }
    }

    flush(opts) {
      const options = opts || {};
      const isCloseTransport = options.transport === 'close';

      if (!this.cfg.endpoint) return;
      if (!this.queue.length) return;
      if (this._flushing) return;

      // backoff applies only to normal flush
      if (!isCloseTransport) {
        const now = Date.now();
        if (now < this._backoffUntil) return;
      }

      if (isCloseTransport) {
        const now2 = Date.now();
        if (now2 - this._lastCloseFlushAt < 1000) return;
        this._lastCloseFlushAt = now2;
      }

      const maxItems = options.maxItems
        ? Math.min(Number(options.maxItems) || 50, this.cfg.maxBatchItems)
        : this.cfg.maxBatchItems;

      if (isCloseTransport) {
        const batch = this._pickCloseBatch(maxItems);
        if (!batch.length) return;

        const payload = safeJson({ sessionId: this.sessionId, logs: batch }, '{}');
        this._sendClose(payload);
        return;
      }

      const batch2 = this._cutBatchByLimits(maxItems, this.cfg.maxBatchBytes);
      if (!batch2.length) return;

      const payload2 = safeJson({ sessionId: this.sessionId, logs: batch2 }, '{}');

      this._flushing = true;

      this._sendNormal(payload2).then((ok) => {
        this._flushing = false;

        if (!ok) {
          this._requeueFront(batch2);
          this._applyBackoff();
          return;
        }

        this._resetBackoff();

        if (this.queue.length >= this.cfg.maxBatchItems || this.queueBytes >= this.cfg.maxBatchBytes) {
          setTimeout(() => this.flush({ reason: 'drain' }), 0);
        }
      });
    }

    _cutBatchByLimits(maxItems, maxBytes) {
      const batch = [];
      let bytes = 0;

      while (this.queue.length && batch.length < maxItems) {
        const next = this.queue[0];
        const b = (next && next._bytes) ? next._bytes : 0;

        if (batch.length > 0 && (bytes + b > maxBytes)) break;

        batch.push(this.queue.shift());
        bytes += b;
      }

      this.queueBytes -= bytes;
      if (this.queueBytes < 0) this.queueBytes = 0;

      // remove internal helper field before sending
      for (let i = 0; i < batch.length; i++) {
        if (batch[i] && batch[i]._bytes != null) delete batch[i]._bytes;
      }

      return batch;
    }

    _requeueFront(batch) {
      // restore internal bytes field
      let bytes = 0;
      for (let i = 0; i < batch.length; i++) {
        const json = safeJson(batch[i], null);
        const b = json ? utf8Bytes(json) : 0;
        batch[i]._bytes = b;
        bytes += b;
      }

      this.queue = batch.concat(this.queue);
      this.queueBytes += bytes;
    }

    _pickCloseBatch(maxItems) {
      const limit = Math.min(this.queue.length, maxItems);

      let batch = [];
      for (let i = 0; i < limit; i++) {
        const candidate = this.queue.slice(0, i + 1).map((x) => {
          if (!x) return x;
          const y = Object.assign({}, x);
          delete y._bytes;
          return y;
        });
        const payload = safeJson({ sessionId: this.sessionId, logs: candidate }, '{}');
        if (utf8Bytes(payload) > this.cfg.closeTransportMaxBytes) break;
        batch = candidate;
      }

      return batch;
    }

    _sendClose(payload) {
      try {
        if (navigator && typeof navigator.sendBeacon === 'function') {
          if (utf8Bytes(payload) > this.cfg.closeTransportMaxBytes) return false;
          // Send as plain text to avoid CORS preflight; payload is JSON string.
          return navigator.sendBeacon(this.cfg.endpoint, payload);
        }
      } catch (e) {}

      // fallback: only fetch keepalive
      try {
        if (window.fetch) {
          const useNoCors = this._shouldUseNoCors();
          fetch(this.cfg.endpoint, {
            method: 'POST',
            mode: useNoCors ? 'no-cors' : 'cors',
            // In no-cors, do NOT set headers (keeps request "simple"); body is a JSON string.
            headers: useNoCors ? undefined : { 'Content-Type': 'application/json' },
            body: payload,
            keepalive: true
          }).catch(() => {});
        }
      } catch (e2) {}

      return false;
    }

    async _sendNormal(payload) {
      if (!window.fetch) return false;

      let controller = null;
      try { controller = new AbortController(); } catch (e) { controller = null; }

      const timeoutId = setTimeout(() => {
        try { if (controller) controller.abort(); } catch (e) {}
      }, this.cfg.timeoutMs);

      try {
        const useNoCors = this._shouldUseNoCors();
        const res = await fetch(this.cfg.endpoint, {
          method: 'POST',
          mode: useNoCors ? 'no-cors' : 'cors',
          // In no-cors, do NOT set headers (keeps request "simple"); body is a JSON string.
          headers: useNoCors ? undefined : { 'Content-Type': 'application/json' },
          body: payload,
          signal: controller ? controller.signal : undefined
        });
        // In no-cors we can't read status/headers (opaque response), so treat "request dispatched" as success.
        if (useNoCors) return true;
        return !!res && res.ok;
      } catch (e) {
        this.log('ERROR', `error inside CuracaoLogger._sendNormal. ${e.message}`)
        return false;
      } finally {
        clearTimeout(timeoutId);
      }
    }

    _shouldUseNoCors() {
      const mode = String(this.cfg.corsMode || 'auto').toLowerCase();
      if (mode === 'no-cors') return true;
      if (mode === 'cors') return false;

      // auto:
      try {
        if (!this.cfg.endpoint) return false;
        const endpointUrl = new URL(this.cfg.endpoint, window.location.href);
        return endpointUrl.origin !== window.location.origin;
      } catch (e) {
        this.log('ERROR', `error inside CuracaoLogger._shouldUseNoCors. ${e.message}`)
        // If URL is invalid, keep current behavior (cors) so it fails loudly.
        return false;
      }
    }

    _sendSingle(entry) {
      // send single entry as its own request (no queue)
      const clean = Object.assign({}, entry);
      delete clean._bytes;

      const payload = safeJson({ sessionId: this.sessionId, logs: [clean] }, '{}');

      // best-effort: use normal transport so we get ACK/backoff behavior
      // but do NOT block caller (fire and forget)
      this._sendNormal(payload).then((ok) => {
        if (!ok) this._applyBackoff();
        else this._resetBackoff();
      });
    }

    _applyBackoff() {
      const base = this.cfg.backoffBaseMs;
      const max = this.cfg.backoffMaxMs;

      this._backoffMs = this._backoffMs ? Math.min(max, this._backoffMs * 2) : base;
      this._backoffUntil = Date.now() + this._backoffMs;
    }

    _resetBackoff() {
      this._backoffMs = 0;
      this._backoffUntil = 0;
    }

    _startTimer() {
      if (this._timer) clearInterval(this._timer);
      this._timer = setInterval(() => this.flush({ reason: 'interval' }), this.cfg.flushIntervalMs);
    }

    _bindCloseFlush() {
      if (!window.addEventListener) return;

      window.addEventListener('visibilitychange', () => {
        if (document && document.visibilityState === 'hidden') {
          this.flush({ transport: 'close', reason: 'hidden', maxItems: 50 });
        }
      });

      window.addEventListener('pagehide', (e) => {
        this.flush({ transport: 'close', reason: 'pagehide', maxItems: 50 });
      });
    }

    _ensureSessionId() {
      if (this.sessionId) return;

      try {
        const stored = sessionStorage.getItem('curacao_logger_session_id_v1');
        if (stored) { this.sessionId = stored; return; }
      } catch (e) {
        this.log('ERROR', `error inside CuracaoLogger._ensureSessionId. ${e.message}`)
      }

      this.sessionId = genId();
      try { sessionStorage.setItem('curacao_logger_session_id_v1', this.sessionId); } catch (e2) {}
    }
  }

  window.CuracaoLogger = CuracaoLogger;
  window.curacaoLogger = window.curacaoLogger || new CuracaoLogger();

  addErrorsListeners()
})(window);